import { DiagramPreset } from "../types/chart";
import { DIAGRAM_PRESET_CATALOG } from "./diagramPresetCatalog";

const built: DiagramPreset[] = DIAGRAM_PRESET_CATALOG.map((e) => ({
  id: e.id,
  gender: e.gender,
  bodyPart: e.bodyPart,
  name: e.name ?? e.bodyPart,
  imageUrl: e.imageUrl,
  tags: e.tags,
}));

built.sort((a, b) => {
  const byPart = a.bodyPart.localeCompare(b.bodyPart, undefined, {
    sensitivity: "base",
  });
  if (byPart !== 0) return byPart;
  return a.gender.localeCompare(b.gender);
});

export const DIAGRAM_PRESETS: DiagramPreset[] = built;

/** Filter chips: unique primary body-area labels (from catalog `bodyPart`). */
const uniqueParts = Array.from(
  new Set(DIAGRAM_PRESETS.map((p) => p.bodyPart)),
).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

export const DIAGRAM_BODY_PART_FILTERS: { id: string; label: string }[] = [
  { id: "all", label: "All" },
  ...uniqueParts.map((label) => ({ id: label, label })),
];
